import { motion } from "framer-motion";

/**
 * RevealText — a masked, line-by-line entrance reveal.
 * Pass `lines` (array of strings) or `text` (single string).
 * Renders each line inside an overflow-hidden container while the inner
 * span translates from 110% to 0. Beautiful for signature hero moments.
 */
export function RevealLines({
  lines,
  as: Tag = "h1",
  className = "",
  itemClassName = "",
  delay = 0,
  stagger = 0.09,
  duration = 0.9,
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden pb-[0.08em]"
          style={{ lineHeight: 1 }}
        >
          <motion.span
            className={`block ${itemClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{
              duration,
              ease: [0.19, 1, 0.22, 1],
              delay: delay + i * stagger,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

/**
 * RevealWords — masked word-by-word reveal. Use for shorter overlines / kickers.
 */
export function RevealWords({
  text,
  as: Tag = "p",
  className = "",
  delay = 0,
  stagger = 0.04,
  duration = 0.7,
}) {
  const words = text.split(" ");
  return (
    <Tag className={className}>
      {words.map((w, i) => (
        <span
          key={i}
          className="inline-block overflow-hidden align-baseline"
          style={{ lineHeight: 1.15 }}
        >
          <motion.span
            className="inline-block"
            initial={{ y: "120%" }}
            animate={{ y: "0%" }}
            transition={{
              duration,
              ease: [0.19, 1, 0.22, 1],
              delay: delay + i * stagger,
            }}
          >
            {w}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
